export default "__VITE_ASSET__syt397cd__"